import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import Select from "../../../AppSelect";
import Swal from 'sweetalert2';

import { customStyles } from "../../../../constants/customSelectStyles";
import NumberInput from '../../../Inputs/Text/Number';
import { subWarehousesMap } from '../../../../utils/enumsUtil';

const AddDetailRow = ({
    show,
    handleClose,
    handleAdd,
    hubInventory,
    hasInventoryAdminPermission,
    viewAllCountriesData,
    countryUserStr,
    fields,
}) => {

    const allowedTypesForNonAdmin = [1, 2, 3, 5];

    const initialValues = {
        shipper: null,
        product: null,
        originSubwarehouseType: { value: 1, label: "Disponible" },
        quantity: ''
    };

    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        watch,
        reset,
        setValue,
    } = useForm({
        defaultValues: initialValues
    });

    const shipperWatcher = watch('shipper');
    const productWatcher = watch('product');
    const originSubwarehouseWatcher = watch('originSubwarehouseType');

    useEffect(() => {
        if (!show) {
            reset(initialValues);
        }
    }, [show, reset]);

    const onSubmit = (data, e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        const detailExist = fields.find((item) =>
            item.shipper.value === data.shipper.value &&
            item.product.value === data.product.value &&
            item.originSubwarehouseType.value === data.originSubwarehouseType.value
        );

        if (detailExist) {
            Swal.fire(
                "Error",
                `Este producto ya se encuentra en la lista, por favor verifique`,
                "error"
            );
            return;
        }

        handleAdd(data);
        setValue('quantity', '');
    };

    const getStock = () => {
        const productInventory = hubInventory?.data?.inventory?.find(item => item.idProduct === productWatcher?.value);

        if (!productInventory || !originSubwarehouseWatcher?.value) return 0;

        const subwarehouseStock = productInventory.stockBySubWarehouse?.find(
            sw => sw.typeSubWarehouse === originSubwarehouseWatcher?.value
        );

        return subwarehouseStock?.availableStock || 0;
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Agregar Detalle</Modal.Title>
            </Modal.Header>
            <form onSubmit={(e) => {
                e.stopPropagation();
                handleSubmit(onSubmit)(e);
            }}>
                <Modal.Body>
                    <div className="row form-group">
                        <div className="col-md-6">
                            <label>Remitente</label>
                            <Controller
                                control={control}
                                name="shipper"
                                rules={{ required: 'Este campo es requerido' }}
                                render={({ field }) => (
                                    <>
                                        <Select
                                            {...field}
                                            styles={customStyles}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setValue('product', null);
                                                setValue('quantity', '');
                                            }}
                                            isClearable
                                            options={
                                                hubInventory?.data?.shippers?.length > 0 ?
                                                    hubInventory?.data.shippers
                                                        .filter(e => (viewAllCountriesData || countryUserStr === null || e.country == countryUserStr))
                                                        .map(item => ({
                                                            value: item.idCompany,
                                                            label: item.name,
                                                        }))
                                                    : []
                                            }
                                        />
                                        {errors.shipper && <span className="error-message">{errors.shipper.message}</span>}
                                    </>
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <label>Producto</label>
                            <Controller
                                control={control}
                                name="product"
                                rules={{ required: 'Este campo es requerido' }}
                                render={({ field }) => (
                                    <>
                                        <Select
                                            {...field}
                                            styles={customStyles}
                                            isClearable
                                            isDisabled={!shipperWatcher?.value}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setValue('quantity', '');
                                            }}
                                            options={
                                                hubInventory?.data?.shippers?.length > 0 && shipperWatcher?.value ?
                                                    hubInventory?.data.shippers
                                                        .find(item => item.idCompany === shipperWatcher?.value)?.products
                                                        ?.map(item => ({
                                                            value: item.idProduct,
                                                            label: item.name,
                                                        })) || []
                                                    : []
                                            }
                                        />
                                        {errors.product && <span className="error-message">{errors.product.message}</span>}
                                    </>
                                )}
                            />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className='col-md-4'>
                            <label>De (Bodega Origen)</label>
                            <Controller
                                control={control}
                                name="originSubwarehouseType"
                                rules={{ required: 'Este campo es requerido' }}
                                render={({ field }) => (
                                    <>
                                        <Select
                                            {...field}
                                            styles={customStyles}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setValue('quantity', '');
                                            }}
                                            isDisabled={!shipperWatcher?.value || !productWatcher?.value}
                                            options={
                                                hasInventoryAdminPermission
                                                    ? subWarehousesMap.map(hub => ({
                                                        value: hub.idType,
                                                        label: hub.name,
                                                    }))
                                                    : subWarehousesMap.filter(hub => allowedTypesForNonAdmin.includes(hub.idType)).map(hub => ({
                                                        value: hub.idType,
                                                        label: hub.name,
                                                    }))
                                            }
                                        />
                                        {errors.originSubwarehouseType && <span className="error-message">{errors.originSubwarehouseType.message}</span>}
                                    </>
                                )}
                            />
                        </div>
                        <div className='col-md-auto'>
                            <label>Existencia</label>
                            <div className="form-control-plaintext text-center">
                                {getStock()}
                            </div>
                        </div>
                        <div className='col-md-2'>
                            <label>Cantidad</label>
                            <NumberInput
                                {...register(`quantity`, {
                                    required: 'Este campo es requerido',
                                    min: {
                                        value: 1,
                                        message: 'La cantidad debe ser mayor a 0',
                                    },
                                    pattern: {
                                        value: /^[0-9]+$/,
                                        message: 'La cantidad debe ser un número entero',
                                    },
                                    validate: (value) => {
                                        const stock = getStock();
                                        return Number(value) <= stock || `La cantidad no puede superar la existencia (${stock})`;
                                    }
                                })}
                                disabled={!shipperWatcher?.value || !productWatcher?.value || !originSubwarehouseWatcher?.value}
                                min={1}
                            />
                            {errors.quantity && <span className="error-message">{errors.quantity.message}</span>}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => reset(initialValues)}
                    >
                        Limpiar
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button variant="primary" type="submit">
                        Agregar
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default AddDetailRow;
